<template>
  <div class="device-manage-topbar">
    <div class="topbar-container">
      <!-- 设备号码搜索 -->
      <div class="search-wrapper-o">
        <input
          type="text"
          placeholder="请输入设备号码"
          class="search-input"
          v-model="deviceId"
          @keyup.enter="searchDevice"
          @input="delStudent"
        />
        <button class="search-confirm-button" @click="searchDevice">
          搜索
        </button>
      </div>
      <!-- 学生姓名搜索 -->
      <div class="search-wrapper-t">
        <input
          type="text"
          placeholder="请输入学生姓名"
          class="search-input"
          v-model="studentName"
          @keyup.enter="searchStudent"
          @input="delDevice"
        />
        <button class="search-confirm-button" @click="searchStudent">
          搜索
        </button>
      </div>
      <!-- 选择状态 (在线/离线/未绑定)-->
      <!-- <div class="sensitiveWord-select-o">
        <el-select
          v-model="statusVal"
          placeholder="选择状态"
          @change="changeStatus"
        >
          <el-option
            :label="item.label"
            :value="item.value"
            v-for="(item, index) in statusOptions"
            :key="index"
          ></el-option>
        </el-select>
      </div> -->
      <!-- 选择是否挂失 -->
      <div class="sensitiveWord-select-o">
        <el-select
          v-model="lossVal"
          placeholder="是否挂失"
          @change="changeLoss"
        >
          <el-option
            v-for="item in lossOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <!-- 选择班级 -->
      <div class="sensitiveWord-select-t">
        <el-cascader
          v-model="className"
          placeholder="选择班级"
          :props="classProps"
          :options="classSelect"
          @change="changeHandle"
        ></el-cascader>
      </div>
      <!-- 重置 -->
      <div class="reset" @click="reset">重置</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      statusOptions: [
        {
          value: "全部",
          label: "全部",
        },
        {
          value: "1",
          label: "在线",
        },
        {
          value: "2",
          label: "离线",
        },
        {
          value: "0",
          label: "未绑定",
        },
      ],
      statusVal: "",
      lossOptions: [
        {
          value: "全部",
          label: "全部",
        },
        {
          value: 1,
          label: "已挂失",
        },
        {
          value: 0,
          label: "未挂失",
        },
      ],
      lossVal: "",
      // 班级年级数据
      classSelectList: [],
      // 处理后的班级年级多选数据
      classSelect: [],
      // 级联选择器属性配置
      classProps: {
        expandTrigger: "hover",
        children: "schoolClassList",
      },
      // 选中后的班级年级
      className: [],
      // 设备号搜索
      deviceId: "",
      // 学生名搜索
      studentName: "",
    };
  },
  created() {
    this.selectSchoolAndGradeAndClassListPC();
  },
  methods: {
    // 搜索输入时清空学生或设备号码内容
    delStudent() {
      this.studentName = "";
    },
    delDevice() {
      this.deviceId = "";
    },
    // 重置
    reset() {
      this.studentName = "";
      this.deviceId = "";
      this.lossVal = "";
      this.statusVal = "";
      this.className = [];
      this.$emit("reset");
    },
    // 搜索设备号
    searchDevice() {
      if (!this.deviceId) {
        this.$message.warning("请输入设备号码!");
        return;
      } else {
        this.$emit("searchDevice", this.deviceId);
      }
    },
    // 搜索学生姓名
    searchStudent() {
      if (!this.studentName) {
        this.$message.warning("请输入学生姓名!");
        return;
      } else {
        this.$emit("searchStudent", this.studentName);
      }
    },
    // 选择状态
    changeStatus(e) {
      // console.log("状态==>",e);
      e = e == "全部" ? "" : e;
      this.$emit("changeStatus", e);
    },
    // 选择是否挂失状态
    changeLoss(e) {
      // console.log("是否挂失==>",e);
      e = e == "全部" ? "" : e;
      this.$emit("changeLoss", e);
    },
    // 选择班级
    changeHandle(e) {
      // console.log("选中的班级==>",e);
      this.$emit("changeHandle", e);
    },
    // 年级和班级选择列表
    selectSchoolAndGradeAndClassListPC() {
      this.get(this.$url.getgradeList, {
        schoolId: this.user.schoolId,
      })
        .then((res) => {
          if (res.code !== 200) {
            return this.$message.error(res.msg);
          }
          this.classSelectList = res.data;
          this.classSelectListLength = this.classSelectList.length;
          // console.log(this.classSelectList.length);
          if (this.classSelectList.length) {
            this.classSelectList.forEach((gItem, g) => {
              let { gradeCode, gradeId, gradeName } = gItem;
              gItem.value = {
                gradeCode,
                gradeId,
                gradeName,
              };
              gItem.label = gItem.gradeName;
              gItem.schoolClassList.forEach((cItem, c) => {
                let { classCode, classId, className } = cItem;
                cItem.value = {
                  classCode,
                  classId,
                  className,
                };
                cItem.label = cItem.className;
              });
            });
            this.classSelect = this.classSelectList;
            // console.log("处理后的数据==>", this.classSelect);
          }
        })
        .catch((err) => {
          // this.$message.error("获取班级列表失败");
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "./deviceManageTopbar.scss";
</style>